import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { Form } from 'vee-validate';
import { ref, computed, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { requestStart } from '@/js/lib/api/item';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import IButton from '@/js/components/molecules/IButton.vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import IModal from '@/js/components/molecules/IModal.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';

const storageKey = 'close_requestballoon';

export default /*@__PURE__*/_defineComponent({
  __name: 'SendRequestButton',
  props: {
    itemId: {},
    shopId: {},
    isMe: {},
    isSubscribed: {}
  },
  setup(__props: any) {

const props = __props;
const userStore = useUserStore();
const memberStore = useMemberStore();
const email = ref('');
const followMember = ref(false);
const mailMagazine = ref(false);
const isShowMenu = ref(false);
const isShowRequestDialog = ref(false);
const isShowErrorDialog = ref(false);
const errorMsg = ref('');
const isFollowed = computed(() => memberStore.followedMemberIds.includes(props.shopId));
const isFirst = computed(() => !getFromStorage({ key: storageKey }));
const isDisabled = computed(() => Boolean(props.isMe) || Boolean(props.isSubscribed));
const onHideMenu = () => {
  setToStorage({ key: storageKey, value: true, expirationSeconds: 86400 * 365 });
};
const onSubmit = () => {
  loading({
    asyncFunc: async () => {
      try {
        await requestStart({
          itemId: props.itemId,
          email: email.value,
          followMember: followMember.value,
          mailMagazine: mailMagazine.value,
        });
        window.location.reload();
      } catch (error) {
        if (error.response.data.message) {
          errorMsg.value = error.response.data.message;
        }
        isShowRequestDialog.value = false;
        isShowErrorDialog.value = true;
      }
    },
  });
};

onMounted(() => {
  isShowMenu.value = !props.isSubscribed && isFirst.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    _createElementVNode("button", {
      disabled: isDisabled.value,
      class: _normalizeClass(_ctx.$style.sendBtn),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isShowRequestDialog.value = true), ["prevent"]))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["icon-envelope-o", _ctx.$style.envelope])
      }, null, 2),
      _cache[7] || (_cache[7] = _createTextVNode()),
      (!_ctx.isSubscribed)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(_ctx.$style.sendLink)
          }, "再出品メールを受け取る", 2))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "再出品メール登録済み"))
    ], 10, _hoisted_1),
    _cache[20] || (_cache[20] = _createTextVNode()),
    (!isDisabled.value)
      ? (_openBlock(), _createBlock(IMenu, {
          key: 0,
          modelValue: isShowMenu.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowMenu).value = $event)),
          title: isFirst.value ? '再出品メールを登録してみませんか？' : '再出品メールとは？',
          width: "300",
          onHide: onHideMenu
        }, {
          link: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["icon-question-circle", _ctx.$style.question])
            }, null, 2)
          ]),
          menu: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" 作品が再出品された時にメールでお知らせします。(※利用者の情報は出品者には通知されません) ")
          ])),
          _: 1,
          __: [9]
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true),
    _cache[21] || (_cache[21] = _createTextVNode()),
    _createVNode(IModal, {
      modelValue: isShowRequestDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isShowRequestDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.lead)
        }, _cache[10] || (_cache[10] = [
          _createTextVNode("作品が再出品された時にメールでお知らせします。"),
          _createElementVNode("br", null, null, -1),
          _createTextVNode("(※利用者の情報は出品者には通知されません)")
        ]), 2),
        _cache[18] || (_cache[18] = _createTextVNode()),
        _createVNode(_unref(Form), { onSubmit: onSubmit }, {
          default: _withCtx(() => [
            (_unref(userStore).isAuthenticated)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(IButton, {
                    type: "primary",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("登録")
                    ])),
                    _: 1,
                    __: [11]
                  }),
                  _cache[13] || (_cache[13] = _createTextVNode()),
                  (!isFollowed.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.check)
                      }, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((followMember).value = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, followMember.value]
                          ]),
                          _cache[12] || (_cache[12] = _createTextVNode(" お気に入りショップに保存する"))
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(ITextField, {
                      modelValue: email.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
                      modelModifiers: { trim: true },
                      name: "メールアドレス",
                      title: "メールアドレス",
                      type: "email",
                      rules: "required|email|max:200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[16] || (_cache[16] = _createTextVNode()),
                  _createVNode(IButton, {
                    type: "primary",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("登録")
                    ])),
                    _: 1,
                    __: [14]
                  }),
                  _cache[17] || (_cache[17] = _createTextVNode()),
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.$style.check)
                  }, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((mailMagazine).value = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, mailMagazine.value]
                      ]),
                      _cache[15] || (_cache[15] = _createTextVNode(" iichiのメールマガジンに登録する"))
                    ])
                  ], 2)
                ], 64))
          ]),
          _: 1
        })
      ]),
      _: 1,
      __: [18]
    }, 8, ["modelValue"]),
    _cache[22] || (_cache[22] = _createTextVNode()),
    _createVNode(IModal, {
      modelValue: isShowErrorDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isShowErrorDialog).value = $event))
    }, {
      default: _withCtx(() => [
        (errorMsg.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMsg.value), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, _cache[19] || (_cache[19] = [
              _createTextVNode("\n        処理中にエラーが発生しました。"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("\n        しばらくしてからもう一度ボタンを押して下さい。"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("\n        何度もエラーが起きる場合はiichi運営事務局までお問い合わせ下さい。\n      ")
            ])))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})